import React from 'react'
import { useParams } from 'react-router-dom'
import cn from 'classnames'
import { Spinner } from '../shared/Spinner'
import { PAGE_STATE } from './constants'
import useCustomerAgreement from './useCustomerAgreement'
import CustomerAgreementView from './CustomerAgreementView'
import styles from './index.module.scss'

export default function CustomerAgreementPage () {
  const { token } = useParams()
  const {
    pageState,
    agreement,
    signerName,
    setSignerName,
    accepted,
    setAccepted,
    formError,
    isSigning,
    canSign,
    handleSubmit
  } = useCustomerAgreement(token)

  if (pageState === PAGE_STATE.LOADING) {
    return <Spinner isFetching />
  }

  const isSigned = pageState === PAGE_STATE.SIGNED

  return (
    <>
      <header className={cn(styles.headerPadding, styles.headerTitle)}>
        <h4 className={cn(styles.headerText)}>
          Terms and Conditions Agreement
        </h4>
      </header>
      <section className={cn(!isSigned && 'dis-panel dis-panel-body', styles.pageWrapper, isSigned && styles.signedPageWrapper)}>
        <CustomerAgreementView
          pageState={pageState}
          agreement={agreement}
          signerName={signerName}
          setSignerName={setSignerName}
          accepted={accepted}
          setAccepted={setAccepted}
          formError={formError}
          isSigning={isSigning}
          canSign={canSign}
          handleSubmit={handleSubmit}
        />
      </section>
    </>
  )
}
